<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong
                    >{{ partner.title }}: {{ discount_card.title }}</strong
                    >
                </CCardHeader>
                <CCardBody>
                    <PartnerDiscountCardTabLinks />

                    <CRow class="ml-1 mt-3">
                        <p>Требования к файлу импорта клиентов:</p>
                    </CRow>
                    <CRow class="ml-1">
                        <ul>
                            <li>- Формат - CSV</li>
                            <li>- Разделитель - ";"</li>
                            <li>- Значения указываются без кавычек</li>
                            <li>- Кодировка файла - "UTF-8"</li>
                        </ul>
                    </CRow>
                    <CRow class="ml-1 mt-3">
                        <p>Последовательность значений в файле:</p>
                    </CRow>
                    <CRow class="ml-1 mb-4">
                        <ul>
                            <li>1. Имя</li>
                            <li>2. Номер телефона</li>
                        </ul>
                    </CRow>

                    <CForm>
                        <CInputFile
                            ref="picture"
                            label="Выберите файл"
                            horizontal
                            class="mt-3"
                            @change="selectPicture"
                        />
                    </CForm>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        @click="executeImport"
                    >Импорт</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnerDiscountCardTabLinks from '@/components/partner/PartnerDiscountCardTabLinks';

    export default {
        name: 'PromotionImport',

        components: {
            PartnerDiscountCardTabLinks,
        },

        data() {
            return {
                partner: {},
                discount_card: {},
                selectedPicture: null,
            };
        },

        computed: {},

        mounted() {
            const partnerId = parseInt(this.$route.params.id);
            const discountCardId = parseInt(this.$route.params.discount_card_id);
            Vue.axios
                .get('/partners/' + partnerId)
                .then(resp => {
                    this.partner = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios
                .get('/discount-cards/' + discountCardId)
                .then(resp => {
                    this.discount_card = resp.data;
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            executeImport() {
                if (!this.selectedPicture) {
                    this.$root.$emit('showError', 'Выберите файл.');
                    return;
                }
                let formData = new FormData();
                formData.append('file', this.selectedPicture);
                Vue.axios
                    .post('/files/upload-raw', formData)
                    .then(resp => {
                        Vue.axios
                            .post('/discount-cards/' + this.discount_card.id + '/import', {
                                filename: resp.data.filename,
                            })
                            .then(resp => {
                                this.$router.push({
                                    path:
                                        '/partners/' +
                                        this.partner.id +
                                        '/discount-cards/' +
                                        this.discount_card.id +
                                        '/clients',
                                });
                            })
                            .catch(err => {
                                this.$root.$emit('showError', 'Ошибка импорта клиентов.');
                            });
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки файла.');
                    });
            },

            selectPicture(FileList) {
                this.selectedPicture = FileList[0];
            },
        },
    };
</script>
<style scoped>
</style>
